import React, { useEffect, useState, useRef, useCallback } from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import "./AssemblyInstructionsPopup.css";
import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd";
import { useDispatch, useSelector } from "react-redux";
import { BsChevronLeft, BsChevronRight } from "react-icons/bs";
import { RiDeleteBinLine } from "react-icons/ri";
import editIcon from "../../../assets/icons/Group2694.svg";
import {
  DeleteInstructionsAsset,
  UpdateInstructions,
  UpdateSupplierContactIndexPositions,
  fetchInstructionsList,
} from "../../../redux/actions/action";
import CardAddButton from "../../../assets/icons/CardAddButton.svg";
import { Switch } from "antd";
import PlusIcon from "../../../assets/images/Plus.svg";
import DownArrow from "../../../assets/icons/arrowdown.svg";
import AssemblyInstructionsTwoPopup from "./AssemblyInstructionsTwoPopup";
import searchicon from "../../../assets/icons/search.svg";
import Package from "../../../assets/icons/package.svg";
const AssemblyInstructionsPopup = (props) => {
  const dispatch = useDispatch();
  const emailInputRefs = useRef([]);
  const assetId = window.localStorage.getItem("assetId");
  const [loading, setLoading] = useState(false);
  const [Touched, setTouched] = useState(false);
  const [mailError, setMailError] = useState({});
  const [assetName, SetAssetName] = useState();
  const [assetImage, SetAssetImage] = useState();
  const [contactDocsList, setContactDocsList] = useState([]);
  const [searchItems, setSearchItems] = useState("");
  const [assemblyModal, showAssemblyModal] = useState(false);

  const [fullInstructionsList, setFullInstructionsList] = useState([]);

  const [supplierContact, setSupplierContact] = useState([
    {
      assetAssemblyInstructionid: "",
      materialName: "",
      title: "",
      instructions: "",
      materialInstructionsVisible: false,
    },
  ]);
  const FetchTranslationList = useSelector(
    (state) => state.user.FetchTranslationList
  );
  const assetsInstructionsList = useSelector(
    (state) => state.user.assetsInstructionsList
  );

  // pagination for Contact start
  const pageSize = 10;
  const [currentPage, setCurrentPage] = useState(1);
  const totalItems = supplierContact.length;
  const totalPages = Math.ceil(totalItems / pageSize);
  const startIndex = (currentPage - 1) * pageSize;
  const endIndex = Math.min(startIndex + pageSize - 1, totalItems - 1);

  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
  };
  // pagination for Contact end

  // pagination for Doc start
  const [paginationObj1, setPaginationObj1] = useState({
    totalRecords: 0,
    currentPage: 0,
    startRecordIndex: 0,
    endRecordIndex: 0,
    totalPages: 0,
    records: [],
  });
  const calculatePagination1 = useCallback(
    (pageNumber) => {
      const records = contactDocsList || [];
      const startRecordIndex = Math.max(10 * pageNumber - 9, 1);
      const endRecordIndex = Math.min(10 * pageNumber, records.length);
      const tempPaginationObj = {
        totalRecords: records.length,
        currentPage: pageNumber,
        startRecordIndex,
        endRecordIndex,
        totalPages: Math.ceil(records.length / 10),
        records: records.slice(startRecordIndex - 1, endRecordIndex),
      };
      setPaginationObj1({ ...tempPaginationObj });
    },
    [contactDocsList]
  );
  useEffect(() => {
    calculatePagination1(1);
  }, [calculatePagination1, contactDocsList]);
  // pagination for Doc end

  const Deletecontactinput = (id) => {
    const deleteData = supplierContact.filter((item, index) => index !== id);
    setSupplierContact(deleteData);
    dispatch(
      DeleteInstructionsAsset(supplierContact[0].assetAssemblyInstructionid)
    );
  };

  useEffect(() => {
    dispatch(fetchInstructionsList(assetId));
  }, []);

  useEffect(() => {
    if (assetsInstructionsList && assetsInstructionsList.status === true) {
      const assetsObject = assetsInstructionsList?.data[0];
      SetAssetName(assetsObject.assetname);
      SetAssetImage(assetsObject.assetimages);
      setSupplierContact(assetsObject.assemblyinstruction);
      setFullInstructionsList(assetsObject.assemblyinstruction);
    }
  }, [assetsInstructionsList]);

  // ASC Drag Drop start
  const handleDragEnd = (data) => {
    // let tempDragData = Array.from(supplierContact);
    let tempDragData = [...supplierContact];
    let [source_Data] = tempDragData.splice(data.source.index, 1);
    tempDragData.splice(data.destination.index, 0, source_Data);
    setSupplierContact(tempDragData);

    // for finding Droppable ids and indexes
    let draggableId = data.draggableId;
    let destinationDropId = data.destination.droppableId;
    let destinationIndex = data.destination.index;
    let sourceDropId = data.source.droppableId;
    let sourceIndex = data.source.index;

    // finding nearbyID using index
    let id22 = data.destination.index;
    let nearbyID = supplierContact.filter((item, index) => index === id22);

    // for sending in API below
    const originalIndexPosition = tempDragData.map((item, index) => ({
      ...item,
      oldIndexPosition: item.indexPosition,
      NewIndexPosition: index, // Updating indexPosition after drag
    }));

    const onlyUpdatedTasks = originalIndexPosition.filter((item, index) => {
      return item.oldIndexPosition !== item.NewIndexPosition;
    });

    const payload = onlyUpdatedTasks.map((item) => {
      return {
        supplierContactid: item.supplierContactid,
        indexPosition: item.NewIndexPosition,
      };
    });

    dispatch(UpdateSupplierContactIndexPositions(payload));
  };
  // ASC Drag Drop end

  const handleInputChange = (index, field, value) => {
    setTouched(true);
    const newInputs = [...supplierContact];
    newInputs[index][field] = value;
    // if (field === "title") {
    //   if (index === newInputs.length - 1 && value !== "") {
    //     newInputs.push({
    //       assetAssemblyInstructionid:"",
    //       materialName: "",
    //       title: "",
    //     });
    //   }
    // }
    setSupplierContact(newInputs);
  };

  const materialInstructionsVisible = (index) => {
    setTouched(true);
    const newInputs = supplierContact.map((contact, i) => ({
      ...contact,
      materialInstructionsVisible:
        i === index ? !contact.materialInstructionsVisible : false,
    }));
    setSupplierContact(newInputs);
  };

  const isFetchList = () => {
    setTimeout(() => {
      dispatch(fetchInstructionsList(assetId));
    }, 1000);
  };

  useEffect(() => {
    if (searchItems) {
      let list = [...fullInstructionsList];
      list = list?.filter((item) => {
        return item.materialName
          .toLowerCase()
          .includes(searchItems.toLowerCase());
      });
      setSupplierContact(list);
    } else {
      setSupplierContact([...fullInstructionsList]);
    }
  }, [searchItems]);

  const handleSubmit = () => {
    const payload = {
      assetId,
      instructions: supplierContact,
    };
    dispatch(UpdateInstructions(payload));
    props.onHide();
  };

  return (
    <>
      <Modal
        {...props}
        id="assembly_instructions_Popup"
        dialogClassName="custum_projectPop"
        // size="md"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Body>
          <div className="assembly_instructions_page_title">
            <h3>Assembly instructions for </h3>
          </div>
          <div className="assembly_instructions_header">
            <div className="assembly_header_images">
              <div className="assembly_header_images_feature">
                {assetImage ? (
                  <>
                    <img
                      src={assetImage}
                      alt=""
                      className="default-img assembly_header_DocImg_uploaded"
                    />
                  </>
                ) : (
                  <>
                    <img
                      src={Package}
                      alt=""
                      className="default-img assembly_header_DocImg"
                    />
                    <div class="product-image-title">Picture</div>
                  </>
                )}
              </div>
              <div className="assembly_instructions_header_title">
                <h3>{assetName}</h3>
              </div>
            </div>
            <div className="assembly_instructions_switch">
              Create and merge into 1 document <Switch />
            </div>
          </div>

          <div className="doc-block">
            <div className="content-block-header">
              <div className="d-flex">
                <div
                  className="d-flex justify-content-center align-items-center gap-2"
                  onClick={() => {
                    showAssemblyModal(true);
                  }}
                  style={{ cursor: "pointer" }}
                >
                  <img
                    src={PlusIcon}
                    className="products-and-parts-addDocImg"
                    alt=""
                  />
                  <p className="pt-1 products-and-parts-addDocText m-0">
                    Add instruction
                  </p>
                </div>
              </div>

              <div className="d-flex justify-content-center align-items-center gap-4 custom-header-padd">
                <div className="search_bar_outer quote-modal-search">
                  <input
                    className="search_bar"
                    value={searchItems}
                    onChange={(e) => setSearchItems(e.target.value)}
                    type="text"
                    placeholder="Search"
                  />
                  <img
                    src={searchicon}
                    alt="Search Icon"
                    style={{
                      flexShrink: "0",
                      width: "17px",
                      height: "17px",
                      marginRight: "8px",
                    }}
                  />
                </div>

                <div className="pagination_outer">
                  {/* pagination for contact start */}
                  <div className="stock-custom-pagination">
                    <div>
                      {startIndex + 1} - {endIndex + 1} of {totalItems}
                    </div>
                    <div className="pagination-buttons">
                      <div
                        className={`update-stock-pagination-button ${currentPage === 1 ? "disabled" : ""
                          }`}
                        onClick={() => handlePageChange(currentPage - 1)}
                      >
                        <BsChevronLeft />
                      </div>
                      <div className="pagination-current-page">
                        {currentPage}
                      </div>
                      <div
                        className={`update-stock-pagination-button ${currentPage === totalPages ? "disabled" : ""
                          }`}
                        onClick={() => handlePageChange(currentPage + 1)}
                      >
                        <BsChevronRight />
                      </div>
                    </div>
                  </div>
                  {/* pagination for contact end */}
                </div>
              </div>
            </div>

            <DragDropContext onDragEnd={handleDragEnd}>
              <Droppable droppableId="ASCindex">
                {(provider) => (
                  <div
                    className="textfieldContent"
                    ref={provider.innerRef}
                    {...provider.droppableProps}
                  >
                    {supplierContact
                      .slice(startIndex, endIndex + 1)
                      .map((item, index) => {
                        const contactIndex = startIndex + index;
                        return (
                          <Draggable
                            key={item.assetAssemblyInstructionid}
                            draggableId={item.assetAssemblyInstructionid}
                            index={index}
                          >
                            {(provider) => (
                              <div
                                key={contactIndex}
                                {...provider.draggableProps}
                                {...provider.dragHandleProps}
                                ref={provider.innerRef}
                              >
                                <div className="documentContent">
                                  <div
                                    style={{
                                      fontSize: "1.3rem",
                                    }}
                                    onClick={() => {
                                      setTouched(true);
                                    }}
                                  >
                                    <img
                                      alt=""
                                      src={editIcon}
                                      style={{
                                        width: "22px",
                                        height: "20px",
                                        marginRight: "0.25rem",
                                      }}
                                    />
                                  </div>

                                  <div className="contactBoxcontent">
                                    <div style={{ width: "45%" }}>
                                      <div className="inputBoxContent">
                                        <div className="labelBox">
                                          <label className="labelText">
                                            {/* Material Name */}
                                            Material Name
                                          </label>
                                        </div>
                                        <input
                                          className="contacttabinput"
                                          value={item.materialName}
                                          name="materialName"
                                          onChange={(e) => {
                                            handleInputChange(
                                              contactIndex,
                                              "materialName",
                                              e.target.value
                                            );
                                          }}
                                          type="text"
                                          placeholder={
                                            FetchTranslationList?.data?.data[28]
                                              ?.translation
                                          }
                                        />
                                      </div>
                                    </div>

                                    <div style={{ width: "45%" }}>
                                      <div
                                        className="inputBoxContent"
                                        style={{
                                          height: "55px",
                                        }}
                                      >
                                        <div className="labelBox">
                                          <label className={"labelText"}>
                                            {/* Title */}
                                            Title
                                          </label>
                                        </div>
                                        <input
                                          ref={(el) =>
                                          (emailInputRefs.current[
                                            contactIndex
                                          ] = el)
                                          }
                                          className={"contacttabinput"}
                                          type="text"
                                          value={item.title}
                                          name="title"
                                          onChange={(e) => {
                                            handleInputChange(
                                              contactIndex,
                                              "title",
                                              e.target.value
                                            );
                                          }}
                                          placeholder={
                                            FetchTranslationList?.data?.data[29]
                                              ?.translation
                                          }
                                        />
                                      </div>
                                      {item.materialInstructionsVisible && (
                                        <div className="materialInstructions">
                                          <div className="labelBox">
                                            <label className={"labelText"}>
                                              {/* Instructions */}
                                              Instructions
                                            </label>
                                          </div>

                                          <div className="materialInstructions-inner">
                                            {/* {item.instructions} */}
                                            <textarea
                                              ref={(el) =>
                                              (emailInputRefs.current[
                                                contactIndex
                                              ] = el)
                                              }
                                              className={"contacttabinput"}
                                              type="text"
                                              value={item.instructions}
                                              name="instructions"
                                              onChange={(e) => {
                                                handleInputChange(
                                                  contactIndex,
                                                  "instructions",
                                                  e.target.value
                                                );
                                              }}
                                              placeholder={
                                                FetchTranslationList?.data
                                                  ?.data[29]?.translation
                                              }
                                            />
                                          </div>
                                        </div>
                                      )}
                                    </div>

                                    <div style={{ width: "5%" }}>
                                      <div className="inputBoxContent text-center">
                                        <img
                                          src={DownArrow}
                                          className={`downarrow11 ${false ? "active" : ""
                                            }`}
                                          alt=""
                                          onClick={() => {
                                            setTouched(true);
                                            materialInstructionsVisible(index);
                                          }}
                                        />
                                      </div>
                                    </div>

                                    <div style={{ width: "5%" }}>
                                      <div className="deleteicon2">
                                        <RiDeleteBinLine
                                          className="deleteiconsize"
                                          style={{
                                            curosor: "pointer",
                                          }}
                                          onClick={() => {
                                            setTouched(true);
                                            Deletecontactinput(index);
                                          }}
                                        />
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            )}
                          </Draggable>
                        );
                      })}
                  </div>
                )}
              </Droppable>
            </DragDropContext>
          </div>
        </Modal.Body>
        <Modal.Footer className="mt-3 justify-content-end px-5">
          <button className="asc_purch_no" onClick={props.onHide}>
            Cancel
          </button>

          {/* <Button onClick={props.handleDelete}>yes</Button> */}
          <button className="asc_purch_yes" onClick={handleSubmit}>
            Change
            {props.loading === true && (
              <div
                className="spinner-border spinner-border-sm ms-2"
                role="status"
              ></div>
            )}
          </button>
        </Modal.Footer>
      </Modal>

      {assemblyModal && (
        <AssemblyInstructionsTwoPopup
          show={assemblyModal}
          onHide={() => showAssemblyModal(false)}
          isFetchList={isFetchList}
          // backdrop="static"
          keyboard={false}
        />
      )}
    </>
  );
};

export default AssemblyInstructionsPopup;
